import Dashboard from "./views/Admin";
import SaleOrders from "./views/Admin/SaleOrders";
import Login from "./views/Auth/Login";
import ResetPassword from "./views/Auth/ResetPassword";
import { CgProfile } from "react-icons/cg";
import CreateNewQuote from "./views/Admin/CreateNewQuote";
import Customers from "./views/Admin/Customers";
import Products from "./views/Admin/Products";
import PurchaseOrderDetails from "./views/Admin/PurchaseOrderDetails";
import PurchaseOrders from "./views/Admin/PurchaseOrders";
import Quotes from "./views/Admin/Quotes";
import SalesOrderDetails from "./views/Admin/SalesOrderDetails";
import Settings from "./views/Admin/Settings";
import SystemSettings from "./views/Admin/SystemSettings";
import UpdatePurchaseOrder from "./views/Admin/UpdatePurchaseOrder";
import VendorDetails from "./views/Admin/VendorDetails";
import Vendors from "./views/Admin/Vendors";
import UpdatePassword from "./views/Auth/UpdatePassword";
import VerifyCode from "./views/Auth/VerifyCode";
import dashboardIcon from "./assets/imgs/dashboard_icon.png";
import moreIcon from "./assets/imgs/more_icon.png";
import productIcon from "./assets/imgs/product_icon.png";
import purchaseIcon from "./assets/imgs/purchase_icon.png";
import quoteIcon from "./assets/imgs/quote_icon.png";
import saleIcon from "./assets/imgs/sale_icon.png";
import settingIcon from "./assets/imgs/setting_icon.png";
import AllowedManufacturers from "./views/Admin/AllowedManufacturers";
import Categories from "./views/Admin/Categories";
import CategoryDetails from "./views/Admin/CategoryDetails";
import CustomerDetails from "./views/Admin/CustomerDetails";
import DnhJobDetails from "./views/Admin/DnhJobDetails";
import DnhJobs from "./views/Admin/DnhJobs";
import Invoice from "./views/Admin/Invoice";
import ManualQuote from "./views/Admin/ManualQuote";
import ManufacturerDetails from "./views/Admin/ManufacturerDetails";
import Manufacturers from "./views/Admin/Manufacturers";
import Notifications from "./views/Admin/Notifications";
import PrintPurchaseOrderPdf from "./views/Admin/PrintPurchaseOrderPdf";
import PrintQuotePdf from "./views/Admin/PrintQuotePdf";
import ProductDetails from "./views/Admin/ProductDetails";
import ReturnOrderDetails from "./views/Admin/ReturnOrderDetails";
import ReturnOrders from "./views/Admin/ReturnOrders";
import ShippingTracking from "./views/Admin/ShippingTracking";
import SubCategories from "./views/Admin/SubCategories";
import SubCategoryDetails from "./views/Admin/SubCategoryDetails";
import UserProfilePage from "./views/Admin/UserProfilePage";
import Reviews from "./views/Admin/Reviews";
import ProductGroups from "./views/Admin/ProductGroups";
import ProductGroupDetails from "./views/Admin/ProductGroupDetails";

var routes = [
  {
    path: "/product-group-details/:id",
    name: "Product Group Details",
    component: ProductGroupDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/index",
    name: "Dashboard",
    component: Dashboard,
    layout: "/admin",
    isMenu: true,
    icon: dashboardIcon,
  },
  {
    path: "/sale-orders",
    name: "Sale Orders",
    component: SaleOrders,
    layout: "/admin",
    isMenu: true,
    icon: saleIcon,
  },

  {
    path: "/customers",
    name: "Customers",
    component: Customers,
    icon: moreIcon,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/vendors",
    name: "Vendors",
    component: Vendors,
    layout: "/admin",
    icon: quoteIcon,
    isMenu: true,
  },
  {
    path: "/vendors-details/:id",
    name: "Vendors Details",
    component: VendorDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/customer-details/:id",
    name: "Customers Details",
    component: CustomerDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/sale-order-details/:id",
    name: "Sales Order Details",
    component: SalesOrderDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/return-order-details/:id",
    name: "Return Order Details",
    component: ReturnOrderDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/product-details/:id",
    name: "Product Details",
    component: ProductDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/new-quote/",
    name: "New Quote",
    component: CreateNewQuote,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/purchase-orders",
    name: "Purchase Orders",
    component: PurchaseOrders,
    layout: "/admin",
    isMenu: true,
    icon: purchaseIcon,
  },
  {
    path: "/purchase-orders-details/:id",
    name: "Purchase Orders",
    component: PurchaseOrderDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/update-purchase-orders-details/:id",
    name: "Purchase Orders",
    component: UpdatePurchaseOrder,
    layout: "/admin",
    isMenu: false,
  },

  {
    path: "/generate-purchase-orders-details/:id",
    name: "Purchase Orders",
    component: PrintPurchaseOrderPdf,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/quotes",
    name: "Quotes",
    component: Quotes,
    layout: "/admin",
    isMenu: true,
    icon: quoteIcon,
  },
  {
    path: "/quote-pdf",
    name: "Quotes",
    component: PrintQuotePdf,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/invoice-pdf",
    name: "Invoice",
    component: Invoice,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/items",
    name: "Products",
    component: Products,
    layout: "/admin",
    isMenu: true,
    icon: productIcon,
  },

  {
    path: "/manufacturers",
    name: "Manufacturers",
    component: Manufacturers,
    layout: "/admin",
    isMenu: true,
    icon: productIcon,
  },
  {
    path: "/return-orders",
    name: "Return Orders",
    component: ReturnOrders,
    layout: "/admin",
    isMenu: true,
    icon: productIcon,
  },

  {
    path: "/manufacturer-details/:id",
    name: "Manufacturers",
    component: ManufacturerDetails,
    layout: "/admin",
    isMenu: false,
    icon: productIcon,
  },

  {
    path: "/settings",
    name: "User Management Settings",
    component: Settings,
    layout: "/admin",
    isMenu: false,
    icon: settingIcon,
  },
  {
    path: "/system-settings",
    name: "System Settings",
    component: SystemSettings,
    layout: "/admin",
    isMenu: false,
    icon: settingIcon,
  },
  {
    path: "/user-profile-page",
    name: "Profile",
    component: UserProfilePage,
    layout: "/admin",
    isMenu: false,
    icon: <CgProfile size={25} />,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    layout: "/auth",
    isMenu: false,
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: ResetPassword,
    layout: "/auth",
    isMenu: false,
  },
  {
    path: "/update-password",
    name: "Update Password",
    component: UpdatePassword,
    layout: "/auth",
    isMenu: false,
  },
  {
    path: "/verify-code",
    name: "Verify Code",
    component: VerifyCode,
    layout: "/auth",
    isMenu: false,
  },
  {
    path: "/manual-quote",
    name: "Manual Quote",
    component: ManualQuote,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/categories",
    name: "Categories",
    component: Categories,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/sub-categories",
    name: "Sub Categories",
    component: SubCategories,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/product-groups",
    name: "Product Variant/Groups",
    component: ProductGroups,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/category-details/:id",
    name: "Category Details",
    component: CategoryDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/subCategory-details/:id",
    name: "Sub Category Details",
    component: SubCategoryDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/allowed-manufacturers",
    name: "Allowed Manufacturers",
    component: AllowedManufacturers,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/dnh-jobs",
    name: "DNH Jobs",
    component: DnhJobs,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/dnh-job-details/:id",
    name: "DNH Job Details",
    component: DnhJobDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/shipping-tracking",
    name: "Tracking",
    component: ShippingTracking,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/reviews",
    name: "Reviews",
    component: Reviews,
    layout: "/admin",
    isMenu: false,
  },
];



export { routes };


